import { createContext, ReactNode, useContext } from 'react';
import { ToastContainer, toast, ToastTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface IComponentProps {
  children: ReactNode;
}

const errorToast = (message: string, autoClose?: number, transition?: ToastTransition) => {
  toast.error(`${message}`, {
    closeButton: true,
    hideProgressBar: true,
    autoClose: autoClose || 5000,
    position: 'bottom-center',
    transition: transition
  });
};

const infoToast = (message: string, autoClose?: number, transition?: ToastTransition) => {
  toast.info(`${message}`, {
    closeButton: false,
    hideProgressBar: true,
    autoClose: autoClose || 5000,
    position: 'bottom-center',
    pauseOnFocusLoss: false,
    transition: transition
  });
};

const ToastProvider: React.FC<IComponentProps> = function ({ children }) {
  return (
    <ToastContext.Provider value={
      {
        state: {},
        actions: {
          errorToast,
          infoToast,
        }
      }
    }>
      <ToastContainer />
      {children}
    </ToastContext.Provider>
  );
};

export const toastProvider = {
  state: {} as {},
  actions: {} as {
    errorToast: (message: string, autoClose?: number, transition?: ToastTransition) => void,
    infoToast: (message: string, autoClose?: number, transition?: ToastTransition) => void,
  }
};

export const ToastContext = createContext<typeof toastProvider>(toastProvider);
export const useToast = () => useContext(ToastContext);

// Expose methods for use in non-react components
export const toastStatic = {
  errorToast,
  infoToast
};

export default ToastProvider;
